
import { Component, Vue } from "vue-property-decorator";
import {
  IDefaultShippingOrderModel,
} from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer } from "@/api/customer";

import { QuotationApproval } from "./types";
import {
  getQuotationList,
  getSalesmanList,
  auditHold,
  removeQuotation,
  getQuotationStatus,
  auditPass,
  cancelPass,
  getPIcode,
  downloadPiTemplate,
} from "@/api/inquiry";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import {UserModule} from "@/store/modules/user";
import checkPermission from "@/utils/permission_btn";
import { formatPrice } from "@/utils/number";
import GenerateAppendPiDialog from "./components/GenerateAppendPiDialog.vue";
@Component({
  name: "quotationAudit",
  components: {
    Pagination,
    GenerateAppendPiDialog,
  },
})
export default class extends Vue {
  formatPrice = formatPrice;
  private PICode_show = false;
  public PICodeInfo = {} as any;
  private total = 0;
  private listLoading = true;
  private currentRow = {} as any;
  private generateAppendPiVisible = false;
  private generateAppendPiRow: Record<string, any> = {};
  private tableHeight = 400;
  private layoutObserver: {
    observe: (target: Element) => void;
    disconnect: () => void;
  } | null = null;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as QuotationApproval[],
  };
  public listParam = {
    inquirySheetCode: null,
    customerId: null,
    startTime: null,
    endTime: null,
    sellerId: null,
    status: null,
    time: [],
  };
  public loading: Boolean = false;
  public searchForm = [
    {
      label: "报价单号",
      prop: "inquirySheetCode",
      key: "inquirySheetCode",
      type: "input",
      value: "",
      placeholder: "请输入报价单号",
    },
    {
      label: "客人简称或编号",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "",
      remote: true,
      remote_method: this.searchCustomer,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "提交时间",
      prop: "time",
      key: "time",
      type: "datePicker",
      value: "",
    },
    {
      label: "销售员",
      prop: "sellerId",
      key: "sellerId",
      type: "select",
      options: [],
      value: "",
      placeholder: "全部",
    },
    {
      label: "状态",
      prop: "status",
      key: "status",
      type: "select",
      value: "",
      options: [],
      placeholder: "全部",
      resetKey: { label: "desc", value: "name" },
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "询报价单号",
      prop: "inquirySheetCode",
      key: "inquirySheetCode",
      show: true,
      disabled: false,
      fixed: true,
      type: "link",
      width: 200,
    },
    {
      label: "客人简称",
      prop: "customerAbbreviation",
      key: "customerAbbreviation",
      show: true,
      disabled: false,
      render: (prop, row)=>{
        if (row.pcName && row.pcName.length > 0){
          return `[${row.pcName}]${prop}`
        }
        return prop
      }
    },
    {
      label: "客人国家",
      prop: "nation",
      key: "nation",
      show: true,
      disabled: false,
    },
    {
      label: "销售员",
      prop: "sellerName",
      key: "sellerName",
      show: true,
      disabled: false,
    },
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      show: true,
      disabled: false,
    },
    {
      label: "报价型号数",
      prop: "recordQuantity",
      key: "recordQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "产品数量",
      prop: "productQuantity",
      key: "productQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "采购总价",
      prop: "purchaseTotalPrice",
      key: "purchaseTotalPrice",
      show: true,
      disabled: false,
    },
    {
      label: "PI总金额",
      prop: "saleTotalPrice",
      key: "saleTotalPrice",
      show: true,
      disabled: false,
      account: ['A','A_B'],
    },
    {
      label: "销售总定价",
      prop: "totalAmountByCompanyPrice",
      key: "totalAmountByCompanyPrice",
      show: true,
      disabled: false,
      account: ['B','A_B'],
    },
    {
      label: "折算利润率",
      prop: "conversionProfitMargin",
      key: "conversionProfitMargin",
      show: true,
      disabled: false,
      account: ['A','A_B'],
    },
    {
      label: "折算利润额",
      prop: "conversionProfitAmount",
      key: "conversionProfitAmount",
      show: true,
      disabled: false,
      account: ['A','A_B'],
    },
    {
      label: "状态",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "待审核",
          code: "",
          click: "",
          key: "status",
          value: "待审核",
          color: "color-black",
        },
        {
          name: "已挂起",
          code: "",
          click: "handleHang",
          key: "status",
          value: "已挂起",
          color: "main-color",
        },
        {
          name: "审批通过",
          code: "",
          click: "",
          key: "status",
          value: "审批通过",
          color: "color-black",
        },
        {
          name: "已审核PI",
          code: "",
          click: "handlePI",
          key: "status",
          value: "已审核PI",
          color: "main-color",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
    {
      label: "审核员",
      prop: "auditor",
      key: "auditor",
      show: true,
      disabled: false,
    },
    {
      label: "提交时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        // {
        //   name: "生成PI",
        //   code: ["createPI"],
        //   click: "handleGeneratePI",
        //   key: "status",
        //   value: "审批通过",
        // },
        {
          name: "生成PI",
          code: '',
          type: "more",
          showKey1: "status",
          showKey1Value: ["审批通过"],
          actions: [
            {
              name: "生成新PI",
              code: ["createPI"],
              click: "handleGeneratePI",
            },
            {
              name: "追加PI",
              code: ["createPI"],
              click: "handleAppendPI",
            }
          ]
        },
        {
          name: "挂起",
          code: ["hang"],
          click: "handleAuditHold",
          key: "status",
          value: "待审核",
        },
        {
          name: "审批通过",
          code: ["passAudit"],
          click: "handleAuditPass",
          key: "status",
          value: "待审核,已挂起",
        },
        {
          name: "编辑",
          code: ["edit"],
          click: "handleEdit",
          key: "status",
          value: "待审核,已挂起",
        },
        {
          name: "删除",
          code: ["delete"],
          click: "handleDelete",
          type: "delete",
          key: "status",
          value: "待审核,已挂起",
        },
        // {
        //   name: "查看单据流",
        //   code: '',
        //   click: "gotoDocumentFlow",
        //   key: "status",
        //   value: "待审核,已挂起,审批通过,已生成PI",
        // },
        {
          name: "取消审核",
          code: ["cancelAudit"],
          click: "handleCancelPass",
          key: "status",
          value: "审批通过",
        },
        {
          name: "下载报价单PI",
          code: "",
          account: ['A', 'A_B'],
          click: "handleDownloadQuotationA",
        },
        {
          name: "下载报价销售订单",
          code: "",
          account: ['B', 'A_B'],
          click: "handleDownloadQuotationB",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;

  created() {
    this.init();
  }

  mounted() {
    const wrap = this.$refs.tableWrap as HTMLElement | undefined;
    const Observer = (window as any).ResizeObserver;
    if (wrap && typeof Observer === "function") {
      this.layoutObserver = new Observer(() => this.updateTableHeight());
      this.layoutObserver.observe(wrap);
    }
    window.addEventListener("resize", this.updateTableHeight);
    this.updateTableHeight();
  }

  activated() {
    this.init();
    this.$nextTick(() => {
      this.updateTableHeight();
    });
  }

  beforeDestroy() {
    if (this.layoutObserver) {
      this.layoutObserver.disconnect();
      this.layoutObserver = null;
    }
    window.removeEventListener("resize", this.updateTableHeight);
  }

  private init() {
    this.getQuotationStatus();
    this.getSalesmanList();
    this.searchCustomer();
    this.getList();
  }

  private updateTableHeight() {
    this.$nextTick(() => {
      const wrap = this.$refs.tableWrap as HTMLElement;
      if (!wrap) {
        return;
      }
      const height = Math.floor(wrap.clientHeight);
      if (height < 200 || height === this.tableHeight) {
        return;
      }
      this.tableHeight = height;
      this.$nextTick(() => {
        const table = this.$refs.quotationTable as any;
        if (table && table.doLayout) {
          table.doLayout();
        }
      });
    });
  }

  private checkBtnPermission(codes: string[]) {
    return checkPermission(codes, (this.$route.meta as any)?.buttonCodes);
  }

  private isValueMatch(value: any, values: string) {
    if (value === undefined || value === null || value === "") {
      return false;
    }
    return values.split(",").includes(String(value));
  }

  private checkAccount(exceptAccounts?: string[]) {
    if (!exceptAccounts || !exceptAccounts.length) {
      return true;
    }
    const userAccounts = UserModule.accountType || [];
    return userAccounts.some((a) => exceptAccounts.includes(a));
  }

  private formatCustomerAbbreviation(row: any) {
    if (row.pcName && row.pcName.length > 0) {
      return `[${row.pcName}]${row.customerAbbreviation}`;
    }
    return row.customerAbbreviation;
  }

  private openGenerateAppendPiDialog(row: any) {
    this.generateAppendPiRow = row || {};
    this.generateAppendPiVisible = true;
  }

  private async getQuotationStatus() {
    const res: any = await getQuotationStatus();
    this.searchForm[4].options = res;
  }

  private async handleDownloadQuotationA(row) {
    // 下载报价单PI

    this.$confirm("确定下载报价单PI吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      closeOnClickModal: false,
      closeOnPressEscape: false,
      closeOnHashChange: false,
      showClose: false,
      type: "warning",
      beforeClose: async (action, instance, done) => {
        if (action === "confirm") {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = "执行中...";
          await downloadPiTemplate(row.row.approvalRecordId, { account: "A" })
            .then(() => {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "执行完毕";
              this.$notify({
                title: "成功",
                message: "下载报价单PI成功",
                type: "success",
                duration: 2000,
              });
              setTimeout(() => {
                done();
              }, 300);
            })
            .catch(() => {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "执行完毕";
              setTimeout(() => {
                done();
              }, 300);
            });
          this.getList();
        } else {
          done();
        }
      },
    });
  }

  private async handleDownloadQuotationB(row) {
    // 下载报价单PI

    this.$confirm("确定下载报价销售订单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      closeOnClickModal: false,
      closeOnPressEscape: false,
      closeOnHashChange: false,
      showClose: false,
      type: "warning",
      beforeClose: async (action, instance, done) => {
        if (action === "confirm") {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = "执行中...";
          await downloadPiTemplate(row.row.approvalRecordId,{ account: "B" })
            .then(() => {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "执行完毕";
              this.$notify({
                title: "成功",
                message: "下载报价单PI成功",
                type: "success",
                duration: 2000,
              });
              setTimeout(() => {
                done();
              }, 300);
            })
            .catch(() => {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "执行完毕";
              setTimeout(() => {
                done();
              }, 300);
            });
          this.getList();
        } else {
          done();
        }
      },
    });
  }

  private async getList() {
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    this.loading = true;
    const { total, list }: any = await getQuotationList(params);
    list.forEach((item, index) => {
      item.sn =
        (index + 1) * 1 + (this.table.pageNumber - 1) * this.table.pageSize;
    });
    this.table.total = +total;
    this.table.list = list;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
      this.updateTableHeight();
    }, 0.3 * 1000);
  }
  public PIclickChange(res) {
    this.PICode_show = false;
    this.$router.push(`/salesOrder?piCode=${res.piCode}`);
  }
  // 导出excel
  private isExporting = false;
  // 导出
  public handleExport() {
    this.isExporting = true;
    const accountType = UserModule.accountType[0];
    let table = this.tableCol.slice(0, this.tableCol.length - 1)
    .filter(v=> {
      // 不同账套，返回不同的字段。根据account中的字段
      if (v.account && v.account.indexOf(accountType) !== -1 ) {
        return v;
      }
      if (!v.account){
        return v;
      }
    });
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => {
      if (v.label === "状态") {
        return "status";
      }else {
        return v.key;
      }
    });
    console.log(this.table.list);
    console.log(table);
    console.log(fieldNames);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, this.table.list),
      `报价单审核-${new Date()}`
    );
    this.isExporting = false;
  }
  //  删除
  public async handleDelete(scope) {
    await removeQuotation(scope.row.approvalRecordId);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 审批通过
  public async handleAuditPass(scope) {
    this.$confirm("确定审批通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(scope.row.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审批通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }
  // 取消审核
  public async handleCancelPass(scope) {
    this.$confirm("确定取消审核吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await cancelPass(scope.row.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }
  private handleEdit(scope) {
    this.$router.push(
      `/editQuotation?id=${scope.row.inquirySheetId}&approvalRecordId=${scope.row.approvalRecordId}`
    );
  }

  private reason = "";
  private async handlePI(scope) {
    const res: any = await getPIcode(scope.row.approvalRecordId);
    // console.log('查询的PIcode',res)
    this.reason = scope.row.remark;
    this.PICodeInfo = res;
    this.PICode_show = true;
    // this.$alert(res.piCode?`<text style="color: red">${res.piCode}</text>`:'', "PI号码", {
    //   confirmButtonText: "复制",
    //   callback: () => {
    //     this.h5Copy(res.piCode?res.piCode:'');
    //   },
    // });
  }
  private h5Copy(content) {
    if (!document.queryCommandSupported("copy")) {
      // 不支持
      return false;
    }
    let textarea = document.createElement("textarea") as any;
    textarea.value = content;
    textarea.readOnly = "readOnly";
    document.body.appendChild(textarea);
    textarea.select(); // 选择对象
    textarea.setSelectionRange(0, content.length); // 核心
    let result = document.execCommand("copy"); // 执行浏览器复制命令
    textarea.remove();
    this.$notify({
      title: "成功",
      message: "复制成功",
      type: "success",
      duration: 2000,
    });
    return result;
  }

  private hang_show = false;
  //挂起原因dialog
  private handleHang(scope) {
    this.currentRow = scope.row;
    this.reason = scope.row.remark;
    this.hang_show = true;
  }
  //编辑挂起原因
  private async updateReason() {
    if (!this.reason) {
      this.$message.error("请输入挂起原因");
      return;
    }
    await auditHold({
      id: this.currentRow.approvalRecordId,
      remark: this.reason,
    }).then(() => {
      this.hang_show = false;
      this.getList();
    });
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[3].options = res;
  }

  // 报价单跳转单据流
  // private gotoDocumentFlow(data) {
  //   this.$router.push({name: "DocumentFlow", params: {type: "BOOKING_ORDER", documentId: data.row.id}});
  // }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[1].options = res;
  }
  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.startTime = time[0];
      rest.endTime = time[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }
  private linkClick(scope) {
    let item = JSON.stringify(scope.row);
    if (item.indexOf("&") != -1) {
      item = item.replace("&", "replace");
    }
    this.$router.push(
      `/quotationDetails?id=${scope.row.inquirySheetId}&item=${item}&approvalRecordId=${scope.row.approvalRecordId}`
    );
  }
  // 挂起
  private async handleAuditHold(scope) {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: scope.row.approvalRecordId,
          remark: value,
        });
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }
  // 生成PI

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }
}
